// Image imports
import electricalQuickImg from "./otherAppAssets/electrical/practiceModes/quick.png";
import electricalUpdates2021Img from "./otherAppAssets/electrical/practiceModes/updates_2021.png";
import electricalStandardImg from "./otherAppAssets/electrical/practiceModes/standard.png";
import electricalOccupationalImg from "./otherAppAssets/electrical/practiceModes/occupational.png";
import electricalServiceDistributionImg from "./otherAppAssets/electrical/practiceModes/service_distribution.png";
import electricalWiringImg from "./otherAppAssets/electrical/practiceModes/wiring.png";
import electricalMotorControlImg from "./otherAppAssets/electrical/practiceModes/motor_control.png";
import electricalCommunicationImg from "./otherAppAssets/electrical/practiceModes/communication.png";
import electricalNoCodebookImg from "./otherAppAssets/electrical/practiceModes/no_codebook.png";
import electricalExamImg from "./otherAppAssets/electrical/practiceModes/exam.png";
import electricalCalculationImg from "./otherAppAssets/electrical/practiceModes/calculation.png";
import electricalCircuitImg from "./otherAppAssets/electrical/practiceModes/circuit.png";
import electricalSpecialImg from "./otherAppAssets/electrical/practiceModes/special.png";

import usQuickImg from "./otherAppAssets/electrical_us/practiceModes/quick.png";
import usStandardImg from "./otherAppAssets/electrical_us/practiceModes/standard.png";
import usOccupationalImg from "./otherAppAssets/electrical_us/practiceModes/occupational.png";
import usServiceDistributionImg from "./otherAppAssets/electrical_us/practiceModes/service_distribution.png";
import usWiringImg from "./otherAppAssets/electrical_us/practiceModes/wiring.png";
import usMotorControlImg from "./otherAppAssets/electrical_us/practiceModes/motor_control.png";
import usSpecialConditionsImg from "./otherAppAssets/electrical_us/practiceModes/special_conditions.png";
import usCommunicationImg from "./otherAppAssets/electrical_us/practiceModes/communication.png";
import usNoCodebookImg from "./otherAppAssets/electrical_us/practiceModes/no_codebook.png";
import usCodebookMemoImg from "./otherAppAssets/electrical_us/practiceModes/code_memorization.png";
import usExamImg from "./otherAppAssets/electrical_us/practiceModes/exam.png";
import usCalculationsImg from "./otherAppAssets/electrical_us/practiceModes/calculations.png";
import usUpdates2023Img from "./otherAppAssets/electrical_us/practiceModes/updates_2023.png";
import usStateAmendImg from "./otherAppAssets/electrical_us/practiceModes/state_amend.png";

import plQuickImg from "./otherAppAssets/plumbing/practiceModes/quick.png";
import plStandardImg from "./otherAppAssets/plumbing/practiceModes/standard.png";
import plOccupationalImg from "./otherAppAssets/plumbing/practiceModes/occupation.png";
import plPipeAssemblyImg from "./otherAppAssets/plumbing/practiceModes/pipe_assembly.png";
import plSewageImg from "./otherAppAssets/plumbing/practiceModes/sewage.png";
import plDistributionImg from "./otherAppAssets/plumbing/practiceModes/distribution.png";
import plFixturesImg from "./otherAppAssets/plumbing/practiceModes/fixtures.png";
import plSteamImg from "./otherAppAssets/plumbing/practiceModes/steam.png";
import plSpecializedImg from "./otherAppAssets/plumbing/practiceModes/specialized.png";
import plNoCodebookImg from "./otherAppAssets/plumbing/practiceModes/no_codebook.png";
import plExamImg from "./otherAppAssets/plumbing/practiceModes/exam.png";

import ibewQuickImg from "./otherAppAssets/ibew_aptitude/practiceModes/quick.png";
import ibewStandardImg from "./otherAppAssets/ibew_aptitude/practiceModes/standard.png";
import ibewExamImg from "./otherAppAssets/ibew_aptitude/practiceModes/exam.png";
import ibewReadingImg from "./otherAppAssets/ibew_aptitude/practiceModes/reading.png";
import ibewFractionsDecimalsImg from "./otherAppAssets/ibew_aptitude/practiceModes/fraction_decimals.png";
import ibewGraphsFunctionsImg from "./otherAppAssets/ibew_aptitude/practiceModes/graph_function.png";
import ibewOrderOperationsImg from "./otherAppAssets/ibew_aptitude/practiceModes/order_operations.png";
import ibewPolynomialImg from "./otherAppAssets/ibew_aptitude/practiceModes/polynomial.png";
import ibewQuadraticsImg from "./otherAppAssets/ibew_aptitude/practiceModes/quadratics.png";
import ibewSequencesImg from "./otherAppAssets/ibew_aptitude/practiceModes/sequences.png";
import ibewSlopesLinearImg from "./otherAppAssets/ibew_aptitude/practiceModes/slopes_linear.png";
import ibewSystemsEquationsImg from "./otherAppAssets/ibew_aptitude/practiceModes/systems_equations.png";
import ibewWordLogicImg from "./otherAppAssets/ibew_aptitude/practiceModes/word_logic.png";

export type AppToBuildStr =
  "electrical" | "plumbing" | "electrical_us" | "plumbing_us" | "ibew_aptitude";

export type Env = "development" | "production";

export let APP_TO_BUILD: AppToBuildStr =
  (import.meta.env.VITE_APP_TO_BUILD as AppToBuildStr) || "electrical";

if (APP_TO_BUILD === "plumbing_us") {
  APP_TO_BUILD = "plumbing";
}

export const ENV = (import.meta.env.VITE_ENVIRONMENT as Env) || "production";

/**
 * Overall App Config
 */
const configs: {
  [app: string]: {
    bundleIds: string[];
    featureSet: { [flag: string]: Boolean };
    appName: string;
    appStoreIds: {
      ios: string;
      android: string;
    };
    appStoreRedirects: {
      ios: string;
      android: string;
    };
    // Refer-a-friend store links. Presence of this block doubles as the
    // per-app feature flag — apps without it (ibew_aptitude) have referrals disabled.
    referral?: {
      appScheme: string;
      appStoreUrl: string;
      playStoreUrl: string;
    };
    termsAndConditionsUrl: string;
    proModeSkus: {
      production: {
        web?: string;
        legacy?: string;
        upgrade?: string;
        sub?: string;
        subMonthly?: string;
        aiSub?: string;
        // DEPRECATED
        lifetime?: string;
        apprenticeTrack?: string;
      };
      development: {
        web?: string;
        legacy?: string;
        upgrade?: string;
        sub?: string;
        subMonthly?: string;
        aiSub?: string;
        // DEPRECATED
        lifetime?: string;
        apprenticeTrack?: string;
      };
    };
    iapHubAppId: string;
    iapHubAPIKey: string;
    backupIapPrice: number;
    backupIapSubscriptionPrice?: number;
    backupIapLifetimePrice?: number;
    backupIapApprenticeTrackPrice?: number;
    backupIapUpgradePrice?: number;
    backupIapMonthlySubscriptionPrice?: number;
    fbAppId: string;
  };
} = {
  electrical: {
    bundleIds: ["com.bluecollarexam.exam-app", "com.bluecollarapp.android"],
    featureSet: {},
    appName: "Red Seal Electrical Exam Prep",
    appStoreIds: { ios: "1527031584", android: "com.bluecollarapp.android" },
    appStoreRedirects: {
      ios: "https://apps.apple.com/ca/app/red-seal-electrical-exam-prep/id1527031584",
      android:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.android",
    },
    referral: {
      appScheme: "dakota-electrical",
      appStoreUrl:
        "https://apps.apple.com/ca/app/red-seal-electrical-exam-prep/id1527031584",
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.android",
    },
    termsAndConditionsUrl:
      "https://dakotatestprep.notion.site/Terms-and-Conditions-619aa70bbd0d43af99219feecb932851",
    proModeSkus: {
      production: {
        upgrade: "prod_TEbU0kPeZylUVJ",
        sub: "prod_T4yP51B2Sszlmf",
        aiSub: "prod_UAJ9l8sve0W8Uj",
        // DEPRECATED
        lifetime: "prod_T4yQOetSH35mco",
        apprenticeTrack: "prod_TrfPzbfDhXfzga",
      },
      development: {
        upgrade: "prod_TEu7EvX3qnd26l",
        sub: "prod_TEglPPLbZtxrFP",
        aiSub: "prod_UAJAjv01LPrOj4",
        // DEPRECATED
        lifetime: "prod_TEgmwze7kbCXt1",
        apprenticeTrack: "prod_TrfRaUhuVAzDlx",
      },
    },
    iapHubAppId: "5f7a404cb115a50e95bee9ec",
    iapHubAPIKey: "UoXIS7CoojFuMeCn4HWweNH27nzg6ks",
    backupIapPrice: 59.99,
    backupIapSubscriptionPrice: 79.0,
    // DEPRECATED
    backupIapLifetimePrice: 189.0,
    backupIapApprenticeTrackPrice: 189.0,
    backupIapUpgradePrice: 79.0,
    fbAppId: "1515236679271310",
  },
  electrical_us: {
    bundleIds: [
      "com.bluecollarexam.exam-app-us",
      "com.bluecollarapp.android_us",
    ],
    featureSet: {},
    appName: "NEC Electrical Exam Prep",
    appStoreIds: { ios: "1673601265", android: "com.bluecollarapp.android_us" },
    appStoreRedirects: {
      ios: "https://apps.apple.com/us/app/nec-electrical-exam-prep/id1673601265",
      android:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.android_us&pli=1",
    },
    referral: {
      appScheme: "dakota-electrical-us",
      appStoreUrl:
        "https://apps.apple.com/us/app/nec-electrical-exam-prep/id1673601265",
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.android_us&pli=1",
    },
    termsAndConditionsUrl:
      "https://dakotatestprep.notion.site/Terms-and-Conditions-619aa70bbd0d43af99219feecb932851",
    proModeSkus: {
      production: {
        sub: "prod_T1vFHPND71dI3B",
      },
      development: {
        sub: "prod_TEgkVS1pZbUyXg",
      },
    },
    iapHubAppId: "63f54c0ceb450e4d497f6aa6",
    iapHubAPIKey: "t0ZUojw4twJBbzuhdYnhpvLBecwKgJ",
    backupIapPrice: 99.99,
    fbAppId: "1515236679271310",
  },
  plumbing: {
    bundleIds: [
      "com.bluecollarexam.plumbing-app",
      "com.bluecollarapp.plumbing",
    ],
    featureSet: {},
    appName: "Red Seal Plumbing Exam Prep by Dakota Test Prep",
    appStoreIds: { ios: "1588837572", android: "com.bluecollarapp.plumbing" },
    appStoreRedirects: {
      ios: "https://apps.apple.com/ca/app/red-seal-plumbing-exam-prep/id1588837572",
      android:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.plumbing",
    },
    referral: {
      appScheme: "dakota-plumbing",
      appStoreUrl:
        "https://apps.apple.com/ca/app/red-seal-plumbing-exam-prep/id1588837572",
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.bluecollarapp.plumbing",
    },
    termsAndConditionsUrl:
      "https://dakotatestprep.notion.site/Terms-and-Conditions-619aa70bbd0d43af99219feecb932851",
    proModeSkus: {
      production: {
        legacy: "prod_T4ySfpHhD3xsMM",
        sub: "prod_Ts20g7AM3OoiWQ",
        subMonthly: "prod_UN8fvd8QYpPDa5",
        aiSub: "prod_UKU9PL8xztICyo",
      },
      development: {
        legacy: "prod_TEgnpy83cm56VH",
        sub: "prod_Ts21qaU2FG599y",
        subMonthly: "prod_UN8hRPAN55el6C",
        aiSub: "prod_UKUSwTabVZGAw5",
      },
    },
    iapHubAppId: "615bc23e9bf07f0c7df1373d",
    iapHubAPIKey: "H4aOkO9JTb4BI1FumXSWmYJAMm9mU",
    backupIapPrice: 59.99,
    backupIapSubscriptionPrice: 79.99,
    backupIapMonthlySubscriptionPrice: 39.99,
    fbAppId: "1515236679271310",
  },
  ibew_aptitude: {
    bundleIds: [
      "com.bluecollarexam.ibew-aptitude",
      "com.bluecollarapp.ibew_aptitude",
    ],
    featureSet: {},
    appName: "IBEW Aptitude Test Prep",
    appStoreIds: {
      ios: "6756401055",
      android: "com.bluecollarexam.ibewaptitude",
    },
    appStoreRedirects: {
      ios: "https://apps.apple.com/app/id6756401055",
      android:
        "https://play.google.com/store/apps/details?id=com.bluecollarexam.ibewaptitude",
    },
    termsAndConditionsUrl:
      "https://dakotatestprep.notion.site/Terms-and-Conditions-619aa70bbd0d43af99219feecb932851",
    proModeSkus: {
      production: {
        sub: "prod_TlGBH4sjxVUnJt",
      },
      development: {
        sub: "prod_TlGJ8cu09ooccq",
      },
    },
    iapHubAppId: "",
    iapHubAPIKey: "",
    backupIapPrice: 59.99,
    fbAppId: "1515236679271310",
  },
};

export const APP_CONFIG = configs[APP_TO_BUILD];

export const AI_PAYWALL_ROUTE =
  APP_TO_BUILD === "electrical" || APP_TO_BUILD === "plumbing"
    ? "/ai-paywall"
    : "/paywall";

/**
 * Config for Tests
 */
export enum ElectricalPracticeTestType {
  QUICK,
  UPDATES_2024,
  STANDARD,
  OCCUPATIONAL_SKILLS,
  SERVICE_DISTRIBUTION,
  WIRING_SYSTEMS,
  MOTOR_CONTROL_SYSTEMS,
  COMMUNICATION_SYSTEMS,
  NO_CODEBOOK,
  RED_SEAL_EXAM,
  CALCULATION_ONLY,
  SPECIAL_SYSTEMS,
  CIRCUIT_CONCEPTS,
  QUESTION_GUIDES,
  BANNER_AI_CHAT,
  ONBOARDING,
}

export enum ElectricalUSPracticeTestType {
  QUICK,
  STANDARD,
  OCCUPATIONAL_SKILLS,
  SERVICE_DISTRIBUTION,
  WIRING_SYSTEMS,
  MOTOR_CONTROL_SYSTEMS,
  SPECIAL_CONDITIONS,
  COMMUNICATION_SYSTEMS,
  NO_CODEBOOK,
  CODEBOOK_MEMORIZATION,
  RED_SEAL_EXAM,
  CALCULATION_ONLY,
  CHANGES_2023,
  STATE_AMENDMENTS,
  BANNER_AI_CHAT,
  QUESTION_GUIDES,
  EXAM_PLAYBOOK,
  ONBOARDING,
}

export enum PlumbingPracticeTestType {
  QUICK,
  STANDARD,
  OCCUPATIONAL,
  PIPE,
  SEWAGE,
  SERVICE,
  FIXTURES,
  STEAM,
  SPECIALIZED,
  NO_CODEBOOK,
  RED_SEAL_EXAM,
  CALCULATION_ONLY,
  ONBOARDING,
  BANNER_AI_CHAT,
}

export enum IbewAptitudePracticeTestType {
  QUICK,
  STANDARD,
  APTITUDE_EXAM,
  READING_COMPREHENSION,
  FRACTIONS_DECIMALS,
  GRAPHS_FUNCTIONS,
  ORDER_OF_OPERATIONS,
  POLYNOMIAL_OPERATIONS,
  QUADRATICS,
  SEQUENCES,
  SLOPES_LINEAR,
  SYSTEMS_OF_EQUATIONS,
  WORD_LOGIC,
  BANNER_AI_CHAT,
  ONBOARDING,
}

const PracticeTestTypeByApp: {
  [app: string]: any;
} = {
  electrical: {
    examType: ElectricalPracticeTestType.RED_SEAL_EXAM,
    numExamTypeQuestions: 100,
    totalExamTimeMinutes: 240,
    quickPracticeType: ElectricalPracticeTestType.QUICK,
    standardType: ElectricalPracticeTestType.STANDARD,
    noCodebookType: ElectricalPracticeTestType.NO_CODEBOOK,
    calculationOnlyType: ElectricalPracticeTestType.CALCULATION_ONLY,
    codebookMemorizationType: null,
    updates2024Type: ElectricalPracticeTestType.UPDATES_2024,
    updates2023Type: null,
    stateAmendmentsType: null,
    enum: ElectricalPracticeTestType,
    practiceTestTypesInOrder: [],
    passingScore: 0.7,
    byState: true,
    aiChat: ElectricalPracticeTestType.BANNER_AI_CHAT,
  },
  electrical_us: {
    examType: ElectricalUSPracticeTestType.RED_SEAL_EXAM,
    numExamTypeQuestions: 100,
    totalExamTimeMinutes: 240,
    passingScore: 0.7,
    quickPracticeType: ElectricalUSPracticeTestType.QUICK,
    standardType: ElectricalUSPracticeTestType.STANDARD,
    noCodebookType: ElectricalUSPracticeTestType.NO_CODEBOOK,
    calculationOnlyType: ElectricalUSPracticeTestType.CALCULATION_ONLY,
    codebookMemorizationType:
      ElectricalUSPracticeTestType.CODEBOOK_MEMORIZATION,
    updates2024Type: null,
    updates2023Type: ElectricalUSPracticeTestType.CHANGES_2023,
    stateAmendmentsType: ElectricalUSPracticeTestType.STATE_AMENDMENTS,
    enum: ElectricalUSPracticeTestType,
    practiceTestTypesInOrder: [
      ElectricalUSPracticeTestType.QUICK,
      ElectricalUSPracticeTestType.STANDARD,
      ElectricalUSPracticeTestType.OCCUPATIONAL_SKILLS,
      ElectricalUSPracticeTestType.SERVICE_DISTRIBUTION,
      ElectricalUSPracticeTestType.WIRING_SYSTEMS,
      ElectricalUSPracticeTestType.MOTOR_CONTROL_SYSTEMS,
      ElectricalUSPracticeTestType.SPECIAL_CONDITIONS,
      ElectricalUSPracticeTestType.COMMUNICATION_SYSTEMS,
    ],
    byState: true,
    aiChat: ElectricalUSPracticeTestType.BANNER_AI_CHAT,
  },
  plumbing: {
    examType: PlumbingPracticeTestType.RED_SEAL_EXAM,
    numExamTypeQuestions: 125,
    totalExamTimeMinutes: 240,
    quickPracticeType: PlumbingPracticeTestType.QUICK,
    standardType: PlumbingPracticeTestType.STANDARD,
    noCodebookType: PlumbingPracticeTestType.NO_CODEBOOK,
    calculationOnlyType: PlumbingPracticeTestType.CALCULATION_ONLY,
    codebookMemorizationType: null,
    updates2024Type: null,
    updates2023Type: null,
    stateAmendmentsType: null,
    enum: PlumbingPracticeTestType,
    practiceTestTypesInOrder: [
      PlumbingPracticeTestType.QUICK,
      PlumbingPracticeTestType.BANNER_AI_CHAT,
      PlumbingPracticeTestType.STANDARD,
      PlumbingPracticeTestType.RED_SEAL_EXAM,
      PlumbingPracticeTestType.OCCUPATIONAL,
      PlumbingPracticeTestType.PIPE,
      PlumbingPracticeTestType.SEWAGE,
      PlumbingPracticeTestType.SERVICE,
      PlumbingPracticeTestType.FIXTURES,
      PlumbingPracticeTestType.STEAM,
      PlumbingPracticeTestType.SPECIALIZED,
      PlumbingPracticeTestType.NO_CODEBOOK,
    ],
    passingScore: 0.7,
    byState: true,
    aiChat: PlumbingPracticeTestType.BANNER_AI_CHAT,
  },
  ibew_aptitude: {
    examType: IbewAptitudePracticeTestType.APTITUDE_EXAM,
    numExamTypeQuestions: 70,
    totalExamTimeMinutes: 90,
    quickPracticeType: IbewAptitudePracticeTestType.QUICK,
    standardType: IbewAptitudePracticeTestType.STANDARD,
    noCodebookType: null,
    calculationOnlyType: null,
    codebookMemorizationType: null,
    updates2024Type: null,
    updates2023Type: null,
    stateAmendmentsType: null,
    enum: IbewAptitudePracticeTestType,
    practiceTestTypesInOrder: [
      IbewAptitudePracticeTestType.QUICK,
      IbewAptitudePracticeTestType.STANDARD,
      IbewAptitudePracticeTestType.APTITUDE_EXAM,
      IbewAptitudePracticeTestType.READING_COMPREHENSION,
      IbewAptitudePracticeTestType.FRACTIONS_DECIMALS,
      IbewAptitudePracticeTestType.GRAPHS_FUNCTIONS,
      IbewAptitudePracticeTestType.ORDER_OF_OPERATIONS,
      IbewAptitudePracticeTestType.POLYNOMIAL_OPERATIONS,
      IbewAptitudePracticeTestType.QUADRATICS,
      IbewAptitudePracticeTestType.SEQUENCES,
      IbewAptitudePracticeTestType.SLOPES_LINEAR,
      IbewAptitudePracticeTestType.SYSTEMS_OF_EQUATIONS,
      IbewAptitudePracticeTestType.WORD_LOGIC,
    ],
    passingScore: 0.7,
    byState: false,
    aiChat: IbewAptitudePracticeTestType.BANNER_AI_CHAT,
  },
};

export const PracticeTestType = PracticeTestTypeByApp[APP_TO_BUILD];

const PRACTICE_TYPE_DATA_BY_APP: { [app: string]: any } = {
  electrical: {
    [ElectricalPracticeTestType.QUICK]: {
      image: electricalQuickImg,
      title: "Quick Practice",
      description: "Practice 5 randomized exam questions",
      mainDescription:
        "Assesses overall performance for exam. Contains all topics including occupational skills, services & distribution, wiring methods, motors, and communication systems.",
      numQuestions: 5,
    },
    [ElectricalPracticeTestType.UPDATES_2024]: {
      image: electricalUpdates2021Img,
      title: "2024 CEC Updates",
      description:
        "Practice exam questions that are new or updated in 2024 Updates",
      mainDescription:
        "Practice 25 exam questions that are new or changed due to updates in 2024 Canadian Electrical Code. ",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalPracticeTestType.STANDARD]: {
      image: electricalStandardImg,
      title: "Standard Practice",
      description:
        "Mini exam with full topic coverage and real topic weightings",
      mainDescription:
        "Assesses overall performance for exam. Contains all topics including occupational skills, services & distribution, wiring methods, motors, and communication systems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalPracticeTestType.OCCUPATIONAL_SKILLS]: {
      image: electricalOccupationalImg,
      title: "Occupational Skills",
      description:
        "Trade knowledge & theory, definitions, clearances, testing equipment, and safety",
      mainDescription:
        "Assesses your ability to perform common occupational skills. Contains topics around safety, tools and equipment, organization, support components, and commission & decommission of electrical systems.",
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Trade knowledge & theory, definitions, clearances, testing equipment, and safety",
    },
    [ElectricalPracticeTestType.SERVICE_DISTRIBUTION]: {
      image: electricalServiceDistributionImg,
      title: "Service & Distribution",
      description:
        "Service sizing, transformers, grounding & bonding, high voltage and protection",
      mainDescription:
        "Assesses your ability to install, service and maintain generation, distribution and service systems. Contains topics around consumer & supply services, meters, protection devices, distribution equipment, UPS, bonding and grounding systems, power generation, renewable energy systems, high voltage systems, and transformers.",
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Service sizing, transformers, grounding & bonding, high voltage and protection",
    },
    [ElectricalPracticeTestType.WIRING_SYSTEMS]: {
      image: electricalWiringImg,
      title: "Wiring Systems",
      description:
        "Branch circuits, devices, lighting, conductor & conduit sizing, and box fill & sizing",
      mainDescription:
        "Assesses your ability to install, service and maintain wiring systems. Contains topics around raceways, cables, enclosures, branch circuitry, HVAC, electric heating, exit and emergency lighting system, and cathodic protection system.",
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Branch circuits, devices, lighting, conductor & conduit sizing, and box fill & sizing",
    },
    [ElectricalPracticeTestType.MOTOR_CONTROL_SYSTEMS]: {
      image: electricalMotorControlImg,
      title: "Motor & Control Systems",
      description:
        "Motor feeder, conductor, & protection sizing, controls, HVAC / compressors",
      mainDescription:
        "Assesses your ability to install, service and maintain motors and control systems. Contains topics around motor starters and controls, drives, motors, and automated control systems.",
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Motor feeder, conductor, & protection sizing, controls, HVAC / refrigeration compressors",
    },
    [ElectricalPracticeTestType.COMMUNICATION_SYSTEMS]: {
      image: electricalCommunicationImg,
      title: "Communication Systems",
      description:
        "Communication circuits, integrated controls & signaling systems",
      mainDescription:
        "Assesses your ability to install, service and maintain signalling and communication systems. Contains topics around fire alarm systems, security and surveillance systems, voice/data/video and community antenna television systems, nurse call systems, and building automation & control systems.",
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Communication circuits, integrated controls & signaling systems",
    },
    [ElectricalPracticeTestType.NO_CODEBOOK]: {
      image: electricalNoCodebookImg,
      title: "No Codebook",
      description:
        "Code-free mode covering theory, trade knowledge & best practices",
      mainDescription:
        "Contains questions that do not require a code book to answer.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalPracticeTestType.RED_SEAL_EXAM]: {
      image: electricalExamImg,
      title: "Exam Simulation",
      resultsTitle: "Exam Simulation",
      description:
        "Practice a simulated exam under timed conditions with no hints",
      mainDescription:
        "Simulates the exam. Contains all topics including occupational skills, services & distribution, wiring methods, motors, and communication systems. Time limited to 4 hours.",
      numQuestions: 100,
    },
    [ElectricalPracticeTestType.CALCULATION_ONLY]: {
      image: electricalCalculationImg,
      title: "Calculations",
      description:
        "Conductor or OC sizing, load, voltage drop, and other code-based math topics",
      mainDescription: `Assesses your ability to apply CEC guidelines to solve calculation-based questions. 
            
Covered Topics:
- Conduit and conductor sizing
- Load calculations
- Voltage drop
- Transformers
- Overcurrent calculations
- and more!`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalPracticeTestType.CIRCUIT_CONCEPTS]: {
      image: electricalCircuitImg,
      title: "Circuit Concepts",
      description:
        "Electrical theory, Ohm’s law, series & parallel, single & 3-phase circuits",
      mainDescription: `Assesses foundational understanding of electrical circuit theory and its practical applications. Here are the covered topics: 

Level 1:
- Ohm’s Law and power calculations
- Series and parallel circuits
- Voltage, current, and resistance relationships

Level 2:
- Single-phase AC circuits
- Power factor and efficiency analysis

Level 3:
- Three-phase circuits`,
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Electrical theory & calculations for DC, AC single phase and 3-phase circuits",
    },
    [ElectricalPracticeTestType.SPECIAL_SYSTEMS]: {
      image: electricalSpecialImg,
      title: "Special & Industrial Systems",
      description:
        "Industrial environments, care, hazardous, and other special locations",
      mainDescription: `Evaluates knowledge of specialized electrical systems and their unique installation and safety requirements.

Covered Topics:
- Hazardous location classifications and wiring methods
- Marinas and similar installations
- Healthcare facilities and patient care areas
- Requirements for industrial environments`,
      numQuestions: 25,
      altNumQuestions: 5,
      breakdownDescription:
        "Special occupancies, industrial equipment & conditions like hazardous or care areas",
    },
  },
  electrical_us: {
    [ElectricalUSPracticeTestType.QUICK]: {
      image: usQuickImg,
      title: "Quick Practice",
      description: "Practice 6 random NEC questions",
      mainDescription: `Quick assessment of your overall ability for your exam. Practice mode includes randomized questions across all topics:
            
Covered Topics:
- Occupational Skills
- Service & Distribution
- Wiring Methods & Devices
- Motor & Controls
- Communications
- Special Systems`,
      numQuestions: 6,
    },
    [ElectricalUSPracticeTestType.STANDARD]: {
      image: usStandardImg,
      title: "Standard Practice",
      description:
        "Mini exam with full topic coverage and real topic weightings",
      mainDescription: `Assess your overall ability on all exam subjects, according to the weighting of your exam

Covered Topics:
- Occupational Skills
- Service & Distribution
- Wiring Methods & Devices
- Motor & Controls
- Communications
- Special Systems`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.OCCUPATIONAL_SKILLS]: {
      image: usOccupationalImg,
      title: "Occupational Skills",
      description:
        "Trade knowledge & theory, definitions, clearances, testing equipment, and safety",
      mainDescription: `Assesses your ability to perform common occupational skills.
            
Covered Topics:
- Safety
- Testing Tools
- Work Organization
- Support Components
- Electrical Systems Commissioning`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.SERVICE_DISTRIBUTION]: {
      image: usServiceDistributionImg,
      title: "Service & Distribution",
      description:
        "Service sizing, transformers, grounding & bonding, high voltage and protection",
      mainDescription: `Assesses your ability to install, service and maintain distribution and service systems.

Covered Topics:
- Consumer Services
- Load Calculations
- Protection Devices
- Distribution Equipment
- Grounding & Bonding
- Transformers
- High Voltage`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.WIRING_SYSTEMS]: {
      image: usWiringImg,
      title: "Wiring Systems",
      description:
        "Branch circuits, devices, lighting, conductor & conduit sizing, and box fill & sizing",
      mainDescription: `Assesses your ability to install, service and maintain wiring systems.

Covered Topics:
- Conductors
- Conduits
- Box Sizing & Wire Fill
- Branch Circuits & Devices
- Lighting & Luminaires
- Heating`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.MOTOR_CONTROL_SYSTEMS]: {
      image: usMotorControlImg,
      title: "Motor & Control Systems",
      description:
        "Motor feeder, conductor, & protection sizing, controls, HVAC / compressors",
      mainDescription: `Assesses your ability to install, service and maintain motors and control systems.

Covered Topics:
- Motor Starters
- Drives
- Motors
- Refrigerant Compressors`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.SPECIAL_CONDITIONS]: {
      image: usSpecialConditionsImg,
      title: "Special Systems",
      description:
        "Special occupancies, equipment & conditions like hazardous or basic care areas",
      mainDescription: `Assesses your ability to install, service and maintain special occupancies, equipment and conditions.

Topics:
- Emergency systems
- Health care facilities
- Mobile homes & home parks
- Places of assembly
- Theaters
- Swimming pools
- Hazardous locations (gas stations, bulk storage plants)
- Photovoltaics`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.COMMUNICATION_SYSTEMS]: {
      image: usCommunicationImg,
      title: "Communication Systems",
      description:
        "Communication circuits, integrated controls & signaling systems",
      mainDescription: `Assesses your ability to install, service and maintain signaling and communication systems.
            
Covered Topics:
- Fire alarm systems
- Security and surveillance systems
- Voice/data/video systems
- Community antenna television systems
- Building automation & control systems`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.NO_CODEBOOK]: {
      image: usNoCodebookImg,
      title: "No Codebook",
      description:
        "Code-free mode covering theory, trade knowledge & best practices",
      mainDescription:
        "Contains questions that do not require a code book to answer.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.CODEBOOK_MEMORIZATION]: {
      image: usCodebookMemoImg,
      title: "Codebook Memorization",
      description:
        "Memorize NEC chapters and lock in trade fundamentals — no codebook needed.",
      mainDescription: `Helps you lock in the NEC sections and concepts that come up again and again. You’ll also practice lookup questions that train you to quickly find answers in the code—even in the more obscure areas like special systems and communications.

Note: These questions are not what you’ll see on the exam—they’re for building trade knowledge and lookup speed.

Covered Topics
- Code Lookups (Including Section 600-900)
- Terminations Temps
- Motors
- Conductors
- Service Sizing
- Voltage Drop
`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.RED_SEAL_EXAM]: {
      image: usExamImg,
      title: "NEC Exam Simulation",
      resultsTitle: "NEC Exam",
      description:
        "Practice a simulated exam under timed conditions with no hints",
      mainDescription: `Simulates the {exam_name} exam. Assess your overall ability on all exam subjects, according to the weighting of your exam. Time limited to {exam_time}.
            
Covered Topics:
- Occupational Skills
- Service & Distribution
- Wiring Methods & Devices
- Motor & Controls
- Communications
- Special Systems`,
      numQuestions: null,
    },
    [ElectricalUSPracticeTestType.CALCULATION_ONLY]: {
      image: usCalculationsImg,
      title: "Calculations",
      description:
        "Conductor or OC sizing, load, voltage drop, and other code-based math topics",
      mainDescription: `Assesses your ability to apply NEC guidelines to solve calculation-based questions.

Topics:
- Load calculations
- Conduit and conductor sizing
- Voltage drop
- Fault current
- Motor sizing, conductor, and overcurrent
- Equipment grounding
- Formulas, tables, and rules from NEC`,
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.CHANGES_2023]: {
      image: usUpdates2023Img,
      title: "2023 NEC Updates",
      description:
        "Practice questions that are new updates and revision in 2023 NEC",
      mainDescription:
        "Assesses your understanding of the latest updates and revisions in the 2023 NEC. Covers topics like new safety regulations, updated installation standards, modifications to existing codes, and emerging technologies. Focuses on the code application of these changes and their impact on electrical installations and maintenance.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [ElectricalUSPracticeTestType.STATE_AMENDMENTS]: {
      image: usStateAmendImg,
      title: "State Amendments",
      description: "Practice questions on the state’s amendments to NEC code",
      mainDescription:
        "Assesses your knowledge of state-specific amendments to the NEC. Covers topics like local code variations, compliance requirements, electrical installations, safety protocols, and inspection standards. Focuses on the implementation and integration of state amendments with standard NEC provisions.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
  },
  plumbing: {
    [PlumbingPracticeTestType.QUICK]: {
      image: plQuickImg,
      title: "Quick Practice",
      description: "Practice 7 random Red Seal questions",
      mainDescription:
        "Assesses overall performance for Red Seal exam. Contains all topics including occupational skills, pipe assembly, sewer & drainage systems, distribution systems, and hydronic heating & steam systems.",
      numQuestions: 7,
    },
    [PlumbingPracticeTestType.STANDARD]: {
      image: plStandardImg,
      title: "Standard Practice",
      description:
        "Mini exam with full topic coverage and real topic weightings",
      mainDescription:
        "Assesses overall performance for Red Seal exam. Contains all topics including occupational skills, pipe assembly, sewer & drainage systems, distribution systems, and hydronic heating & steam systems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.OCCUPATIONAL]: {
      image: plOccupationalImg,
      title: "Occupational Skills",
      description:
        "Tools, safety, lifting practices, materials handling, and jobsite procedures",
      mainDescription:
        "Assesses your ability to perform common occupational skills. Contains topics around safety, tools and equipment, organization, support components, and routine trade activities for plumbers.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.PIPE]: {
      image: plPipeAssemblyImg,
      title: "Pipe Assembly",
      description:
        "Pipe materials, joining techniques, spacing, cutting methods, and layout",
      mainDescription:
        "Assesses your ability to preparing & joining pipe and tubing. Contains topics around pipe inspection, cutting & bending pipe, and how to join different types of pipe.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.SEWAGE]: {
      image: plSewageImg,
      title: "Sewage, Drainage & Venting",
      description:
        "Drainage design, vent sizing, trap types, cleanout placement, and pipe slope",
      mainDescription:
        "Assesses your ability to install, service and maintain sewer or DWV (drainage, waste & vent) systems. Contains topics around pipe sizing for sewer & DWV systems, installation & servicing sewer & DWV systems, and treatment of sewage.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.SERVICE]: {
      image: plDistributionImg,
      title: "Service & Distribution",
      description:
        "Water supply layout, backflow prevention, pressure control, pipe sizing, and routing",
      mainDescription:
        "Assesses your ability to install, service and maintain water services, potable water, and pressure systems. Contains topics around pipe sizing and installation/servicing/testing for water services, potable water systems, and pressure systems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.FIXTURES]: {
      image: plFixturesImg,
      title: "Fixtures & Appliances",
      description:
        "Toilets, sinks, dishwashers, heaters, treatment units, and installation rules",
      mainDescription:
        "Assesses your ability to install, service and maintain plumbing fixtures and appliances and water treatment equipment. Includes planning & installation of fixture supports.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.STEAM]: {
      image: plSteamImg,
      title: "Steam & Hydronic Heating",
      description:
        "Steam piping, hydronic loops, boiler components, expansion, and flow control",
      mainDescription:
        "Assesses your ability to install, service and maintain low pressure steam and hydronic systems. Contains topics around pipe sizing and installation/servicing/testing for low pressure steam and heating & cooling hydronic systems. Also includes hydronic transfer units & system controls.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.SPECIALIZED]: {
      image: plSpecializedImg,
      title: "Specialized Plumbing",
      description:
        "Medical gas, solar, reclaimed water, specialty piping, and hazard control",
      mainDescription:
        "Assesses your ability to install, service and maintain specialized and process piping systems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.NO_CODEBOOK]: {
      image: plNoCodebookImg,
      title: "No Codebook",
      description:
        "Code-free mode covering theory, trade knowledge, and best practices",
      mainDescription:
        "Contains questions that do not require a code book to answer.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [PlumbingPracticeTestType.RED_SEAL_EXAM]: {
      image: plExamImg,
      title: "Red Seal Exam Simulation",
      resultsTitle: "Red Seal Exam",
      description:
        "Practice a simulated exam under timed conditions with no hints",
      mainDescription:
        "Simulates Red Seal exam. Contains all topics including  occupational skills, pipe assembly, sewer & drainage systems, distribution systems, hydronic heating & steam systems, and specialized systems. Time limited to 4 hours.",
      numQuestions: 125,
    },
  },
  ibew_aptitude: {
    [IbewAptitudePracticeTestType.QUICK]: {
      image: ibewQuickImg,
      title: "Quick Practice",
      description: "Practice 5 randomized IBEW exam questions",
      mainDescription:
        "Short, focused sets designed to reinforce key concepts and test understanding quickly. Ideal for reviewing a single topic or warming up before longer study sessions. Provides rapid feedback to highlight strengths and gaps.",
      numQuestions: 5,
      numPassages: 0,
    },
    [IbewAptitudePracticeTestType.STANDARD]: {
      image: ibewStandardImg,
      title: "Standard Practice",
      description:
        "Mini exam with full topic coverage and real topic weightings",
      mainDescription:
        "Medium-length practice sets that simulate the pace and variety of the IBEW aptitude test. Covers multiple topics in one session to build accuracy, timing, and endurance. Helps students identify recurring mistakes and improve test-taking strategy.",
      numQuestions: 25,
      altNumQuestions: 5,
      numPassages: 1,
      altNumPassages: 0, // No passages for short mode
      altNumRCNonPassageQuestions: 2,
    },
    [IbewAptitudePracticeTestType.APTITUDE_EXAM]: {
      image: ibewExamImg,
      title: "Exam Simulation",
      resultsTitle: "IBEW Aptitude Exam",
      description:
        "Practice a simulated exam under timed conditions with no hints",
      mainDescription:
        "A full-length practice exam modeled closely after the IBEW aptitude test format and difficulty. Designed to replicate real testing conditions, including timing and question distribution. Best used to measure true readiness and build confidence before test day.",
      numQuestions: 70,
      numPassages: 2,
    },
    [IbewAptitudePracticeTestType.READING_COMPREHENSION]: {
      image: ibewReadingImg,
      title: "Reading Comprehension",
      description:
        "Interpret passages and word problems to find key details and context",
      mainDescription:
        "Interpret written passages and word problems to identify relevant information and understand context. Determine what the question is truly asking before performing any calculations. Filter out unnecessary details and focus on key constraints, values, and relationships.",
      numQuestions: 15,
      altNumQuestions: 5,
      numPassages: 1,
      altNumPassages: 0,
    },
    [IbewAptitudePracticeTestType.FRACTIONS_DECIMALS]: {
      image: ibewFractionsDecimalsImg,
      title: "Fraction & Decimals",
      description:
        "Perform operations and conversions between fractions and decimals",
      mainDescription:
        "Perform arithmetic operations with fractions and decimals, including addition, subtraction, multiplication, and division. Convert between fractions, decimals, and percentages as needed. Apply these skills accurately in both standalone calculations and real-world problems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.GRAPHS_FUNCTIONS]: {
      image: ibewGraphsFunctionsImg,
      title: "Graphs & Functions",
      description: "Read, plot, and interpret linear and quadratic graphs",
      mainDescription:
        "Read and interpret graphs to understand relationships between variables. Plot linear and quadratic functions using tables, intercepts, or given equations. Analyze key features such as slope, direction, intercepts, and points of intersection.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.ORDER_OF_OPERATIONS]: {
      image: ibewOrderOperationsImg,
      title: "Order of Operations",
      description: "Apply BEDMAS/PEMDAS to solve expressions correctly",
      mainDescription:
        "Apply the correct order of operations using BEDMAS or PEMDAS. Evaluate expressions step by step to avoid common calculation errors. Recognize how parentheses, exponents, and division or multiplication affect results.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.POLYNOMIAL_OPERATIONS]: {
      image: ibewPolynomialImg,
      title: "Polynomial Ops & Factoring",
      description: "Simplify, expand, and factor polynomial expressions",
      mainDescription:
        "Simplify and manipulate polynomial expressions through addition, subtraction, multiplication, and division. Expand expressions using distributive properties and combine like terms. Factor polynomials to reveal roots or simplify problem solving.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.QUADRATICS]: {
      image: ibewQuadraticsImg,
      title: "Quadratics",
      description: "Solve quadratic equations by factoring or formula",
      mainDescription:
        "Solve quadratic equations using factoring, completing the square, or the quadratic formula. Identify the number and type of solutions based on the equation. Apply these methods to both algebraic and practical problems.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.SEQUENCES]: {
      image: ibewSequencesImg,
      title: "Sequences",
      description:
        "Identify patterns and find missing terms in numeric sequences",
      mainDescription:
        "Recognize patterns in numeric and algebraic sequences. Determine whether a sequence is arithmetic, geometric, or follows another rule. Use the pattern to find missing terms or predict future values.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.SLOPES_LINEAR]: {
      image: ibewSlopesLinearImg,
      title: "Slopes & Linear",
      description: "Calculate slope, intercepts, and write linear equations",
      mainDescription:
        "Calculate slope using two points or a graph. Identify and interpret x- and y-intercepts. Write linear equations in standard, slope-intercept, or point-slope form.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.SYSTEMS_OF_EQUATIONS]: {
      image: ibewSystemsEquationsImg,
      title: "Systems of Equations",
      description: "Solve for unknowns using substitution or elimination",
      mainDescription:
        "Solve systems of equations using substitution or elimination methods. Determine whether systems have one solution, no solution, or infinitely many solutions. Interpret solutions in real-world contexts where multiple constraints apply.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
    [IbewAptitudePracticeTestType.WORD_LOGIC]: {
      image: ibewWordLogicImg,
      title: "Word & Logic Problems",
      description:
        "Translate real-world problems into equations and reason through solutions",
      mainDescription:
        "Translate written problems into mathematical equations or expressions. Use logical reasoning to choose appropriate strategies and steps. Check solutions to ensure they make sense within the given context.",
      numQuestions: 25,
      altNumQuestions: 5,
    },
  },
};

export const PRACTICE_TYPE_DATA = PRACTICE_TYPE_DATA_BY_APP[APP_TO_BUILD];

const SECTION_TO_SUBSECTION_IDS_BY_APP: {
  [appType: string]: { [key: number]: number[] };
} = {
  electrical: {
    1: [1, 2, 3, 4, 5, 6],
    2: [7, 8, 9, 10, 11, 12, 13, 14, 15],
    3: [16, 17, 18, 19, 20, 21],
    4: [22, 23, 24, 25],
    5: [26, 27, 28],
    6: [29, 30, 21],
    7: [32],
  },
  electrical_us: {
    1: [1, 2, 3, 4, 5, 6],
    2: [7, 8, 9, 10, 11, 12, 13, 14, 15],
    3: [16, 17, 18, 19, 20, 21],
    4: [22, 23, 24, 25],
    5: [26, 27, 28],
    6: [29, 30, 31, 32, 33, 34, 35],
  },
  plumbing: {
    1: [1, 2, 3, 4, 5],
    2: [6, 7],
    3: [8, 9, 10],
    4: [11, 12, 13],
    5: [14, 15],
    6: [16, 17, 18, 19],
    7: [22, 23],
  },
  ibew_aptitude: {
    1: [1],
    2: [2],
    3: [3],
    4: [4],
    5: [5],
    6: [6],
    7: [7],
    8: [8],
    9: [9],
    10: [10],
  },
};
export const SECTION_TO_SUBSECTION_IDS =
  SECTION_TO_SUBSECTION_IDS_BY_APP[APP_TO_BUILD];

const PRACTICE_TEST_TYPE_TO_SECTION_ID_BY_APP: {
  [appType: string]: {
    [testType: string]: number;
  };
} = {
  electrical: {
    [ElectricalPracticeTestType.OCCUPATIONAL_SKILLS]: 1,
    [ElectricalPracticeTestType.SERVICE_DISTRIBUTION]: 2,
    [ElectricalPracticeTestType.WIRING_SYSTEMS]: 3,
    [ElectricalPracticeTestType.MOTOR_CONTROL_SYSTEMS]: 4,
    [ElectricalPracticeTestType.COMMUNICATION_SYSTEMS]: 5,
    [ElectricalPracticeTestType.SPECIAL_SYSTEMS]: 6,
    [ElectricalPracticeTestType.CIRCUIT_CONCEPTS]: 7,
  },
  electrical_us: {
    [ElectricalUSPracticeTestType.OCCUPATIONAL_SKILLS]: 1,
    [ElectricalUSPracticeTestType.SERVICE_DISTRIBUTION]: 2,
    [ElectricalUSPracticeTestType.WIRING_SYSTEMS]: 3,
    [ElectricalUSPracticeTestType.MOTOR_CONTROL_SYSTEMS]: 4,
    [ElectricalUSPracticeTestType.COMMUNICATION_SYSTEMS]: 5,
    [ElectricalUSPracticeTestType.SPECIAL_CONDITIONS]: 6,
  },
  plumbing: {
    [PlumbingPracticeTestType.OCCUPATIONAL]: 1,
    [PlumbingPracticeTestType.PIPE]: 2,
    [PlumbingPracticeTestType.SEWAGE]: 3,
    [PlumbingPracticeTestType.SERVICE]: 4,
    [PlumbingPracticeTestType.FIXTURES]: 5,
    [PlumbingPracticeTestType.STEAM]: 6,
    [PlumbingPracticeTestType.SPECIALIZED]: 7,
  },
  ibew_aptitude: {
    [IbewAptitudePracticeTestType.READING_COMPREHENSION]: 1,
    [IbewAptitudePracticeTestType.FRACTIONS_DECIMALS]: 2,
    [IbewAptitudePracticeTestType.GRAPHS_FUNCTIONS]: 3,
    [IbewAptitudePracticeTestType.ORDER_OF_OPERATIONS]: 4,
    [IbewAptitudePracticeTestType.POLYNOMIAL_OPERATIONS]: 5,
    [IbewAptitudePracticeTestType.QUADRATICS]: 6,
    [IbewAptitudePracticeTestType.SEQUENCES]: 7,
    [IbewAptitudePracticeTestType.SLOPES_LINEAR]: 8,
    [IbewAptitudePracticeTestType.SYSTEMS_OF_EQUATIONS]: 9,
    [IbewAptitudePracticeTestType.WORD_LOGIC]: 10,
  },
};
export const PRACTICE_TEST_TYPE_TO_SECTION_ID =
  PRACTICE_TEST_TYPE_TO_SECTION_ID_BY_APP[APP_TO_BUILD];

const inverse_dict: { [sectionId: number]: string } = {};
// @ts-ignore
Object.entries(PRACTICE_TEST_TYPE_TO_SECTION_ID).forEach(([key, value]) => {
  inverse_dict[value] = key;
});
export const SECTION_ID_TO_PRACTICE_TEST_TYPE = inverse_dict;

const NUM_SECTIONS_BY_APP: {
  [appType: string]: number;
} = {
  electrical: 7,
  electrical_us: 6,
  plumbing: 7,
  ibew_aptitude: 10,
};
export const NUM_SECTIONS = NUM_SECTIONS_BY_APP[APP_TO_BUILD];

const TEST_TYPE_TO_RESULT_TITLE_BY_APP: {
  [appType: string]: {
    [testType: string]: string;
  };
} = {
  electrical: {
    [ElectricalPracticeTestType.OCCUPATIONAL_SKILLS]: "Occupational",
    [ElectricalPracticeTestType.SERVICE_DISTRIBUTION]: "Service & Distribution",
    [ElectricalPracticeTestType.WIRING_SYSTEMS]: "Wiring Methods",
    [ElectricalPracticeTestType.MOTOR_CONTROL_SYSTEMS]: "Motors & Controls",
    [ElectricalPracticeTestType.COMMUNICATION_SYSTEMS]: "Communications",
    [ElectricalPracticeTestType.SPECIAL_SYSTEMS]:
      "Special & Industrial Systems",
    [ElectricalPracticeTestType.CIRCUIT_CONCEPTS]: "Circuit Concepts",
  },
  electrical_us: {
    [ElectricalUSPracticeTestType.OCCUPATIONAL_SKILLS]: "Occupational",
    [ElectricalUSPracticeTestType.SERVICE_DISTRIBUTION]:
      "Service & Distribution",
    [ElectricalUSPracticeTestType.WIRING_SYSTEMS]: "Wiring Methods",
    [ElectricalUSPracticeTestType.MOTOR_CONTROL_SYSTEMS]: "Motors & Controls",
    [ElectricalUSPracticeTestType.COMMUNICATION_SYSTEMS]: "Communications",
    [ElectricalUSPracticeTestType.SPECIAL_CONDITIONS]: "Special Systems",
  },
  plumbing: {
    [PlumbingPracticeTestType.OCCUPATIONAL]: "Occupational Skills",
    [PlumbingPracticeTestType.PIPE]: "Pipe Assembly",
    [PlumbingPracticeTestType.SEWAGE]: "Sewage, Drainage & Venting",
    [PlumbingPracticeTestType.SERVICE]: "Service & Distribution",
    [PlumbingPracticeTestType.FIXTURES]: "Fixtures & Appliances",
    [PlumbingPracticeTestType.STEAM]: "Steam & Hydronic Heating",
    [PlumbingPracticeTestType.SPECIALIZED]: "Specialized Plumbing",
  },
  ibew_aptitude: {
    [IbewAptitudePracticeTestType.READING_COMPREHENSION]:
      "Reading Comprehension",
    [IbewAptitudePracticeTestType.FRACTIONS_DECIMALS]: "Fractions & Decimals",
    [IbewAptitudePracticeTestType.GRAPHS_FUNCTIONS]: "Graphs & Functions",
    [IbewAptitudePracticeTestType.ORDER_OF_OPERATIONS]: "Order of Operations",
    [IbewAptitudePracticeTestType.POLYNOMIAL_OPERATIONS]:
      "Polynomial Operations",
    [IbewAptitudePracticeTestType.QUADRATICS]: "Quadratics",
    [IbewAptitudePracticeTestType.SEQUENCES]: "Sequences",
    [IbewAptitudePracticeTestType.SLOPES_LINEAR]: "Slopes & Linear Equations",
    [IbewAptitudePracticeTestType.SYSTEMS_OF_EQUATIONS]: "Systems of Equations",
    [IbewAptitudePracticeTestType.WORD_LOGIC]: "Word & Logic Problems",
  },
};
export const TEST_TYPE_TO_RESULT_TITLE =
  TEST_TYPE_TO_RESULT_TITLE_BY_APP[APP_TO_BUILD];

/**
 * Firebase database config
 */

const FIREBASE_DB_CONFIG_BY_APP: {
  [appType: string]: {
    allQuestions: string;
    deletedAllQuestions: string;
    questionFrequencies: string;
    curriculum: string;
    typesMinMax: string;
    devices: string;
    showRestore: string;
    forceUpdate: string;
    practiceDays: string;
    tests: string;
    reportedQuestions: string;
    accessCodes: string;
    hideAccessCodes: string;
    inAppBannerInfo: string;
    stateInfo: string;
    subsectionNames: string;
    aiFeedback: string;
    lessons: string;
    aiChatHistory: string;
    aiLimits?: string;
    newPurchaseState: string;
    questionGuides?: string;
    examGuides?: string;
  };
} = {
  electrical: {
    allQuestions: "all_questions_new",
    deletedAllQuestions: "deleted_all_questions_new",
    questionFrequencies: "question_frequencies",
    curriculum: "curriculum_split_new",
    typesMinMax: "types_min_max_new",
    devices: "devices",
    showRestore: "show_restore",
    forceUpdate: "force_update",
    practiceDays: "practice_days",
    tests: "tests",
    reportedQuestions: "reported_questions",

    accessCodes: "access_codes",
    hideAccessCodes: "hide_access_codes",
    inAppBannerInfo: "banner_info",
    stateInfo: "state_info",
    subsectionNames: "subsection_names",
    aiFeedback: "ai_feedback",
    lessons: "lessons",
    aiChatHistory: "ai_chat_history",
    newPurchaseState: "new_purchase_state",
    questionGuides: "question_guides",
  },
  electrical_us: {
    allQuestions: "US_all_questions",
    deletedAllQuestions: "US_deleted_all_questions",
    questionFrequencies: "US_question_frequencies",
    typesMinMax: "US_types_min_max",
    curriculum: "US_curriculum_split",
    devices: "US_devices",
    showRestore: "US_show_restore",
    forceUpdate: "US_force_update",
    practiceDays: "US_practice_days",
    tests: "US_tests",
    reportedQuestions: "US_reported_questions",

    accessCodes: "US_access_codes",
    hideAccessCodes: "US_hide_access_codes",
    inAppBannerInfo: "US_banner_info",
    stateInfo: "US_state_info",
    subsectionNames: "US_subsection_names",
    aiFeedback: "US_ai_feedback",
    lessons: "US_lessons",
    aiChatHistory: "US_ai_chat_historys",
    newPurchaseState: "US_new_purchase_state",
    questionGuides: "US_question_guides",
    examGuides: "US_exam_guides",
  },
  plumbing: {
    allQuestions: "plumbing_all_questions",
    deletedAllQuestions: "deleted_plumbing_all_questions",
    questionFrequencies: "plumbing_question_frequencies",
    curriculum: "plumbing_curriculum_split_new",
    typesMinMax: "plumbing_types_min_max",
    devices: "plumbing_devices",
    showRestore: "plumbing_show_restore",
    forceUpdate: "plumbing_force_update",
    practiceDays: "plumbing_practice_days",
    tests: "plumbing_tests",
    reportedQuestions: "plumbing_reported_questions",

    accessCodes: "plumbing_access_codes",
    hideAccessCodes: "plumbing_hide_access_codes",
    inAppBannerInfo: "plumbing_banner_info",
    stateInfo: "",
    subsectionNames: "",
    aiFeedback: "plumbing_ai_feedback",
    lessons: "plumbing_lessons",
    aiChatHistory: "plumbing_ai_history",
    newPurchaseState: "plumbing_new_purchase_state",
  },
  ibew_aptitude: {
    allQuestions: "ibew_all_questions",
    deletedAllQuestions: "ibew_deleted_questions",
    questionFrequencies: "ibew_question_frequencies",
    curriculum: "ibew_curriculum_split",
    typesMinMax: "ibew_types_min_max",
    devices: "ibew_devices",
    showRestore: "ibew_show_restore",
    forceUpdate: "ibew_force_update",
    practiceDays: "ibew_aptitude_practice_days",
    tests: "ibew_tests",
    reportedQuestions: "ibew_reported_questions",

    accessCodes: "ibew_access_codes",
    hideAccessCodes: "ibew_hide_access_codes",
    inAppBannerInfo: "ibew_banner_info",
    stateInfo: "",
    subsectionNames: "ibew_subsection_names",
    aiFeedback: "ibew_ai_feedback",
    lessons: "ibew_lessons",
    aiChatHistory: "ibew_ai_history",
    aiLimits: "ibew_ai_limits",
    newPurchaseState: "ibew_aptitude_new_purchase_state",
  },
};
export const FIREBASE_DB_CONFIG = FIREBASE_DB_CONFIG_BY_APP[APP_TO_BUILD];
